import apiBase from "@/api/unversioned/apiBase";
import { type AxiosRequestConfig } from "axios";
import { DownloadReportRequest } from "@/global/interfaces";
const baseURL = `${import.meta.env.VITE_API_BASE_URL}/report/download/`;

const getAll = async (path: string, config?: AxiosRequestConfig) => {
  const url = `${baseURL}${path}`;
  return apiBase("get", url, config);
};
const post = async (requestBody: DownloadReportRequest, config?: AxiosRequestConfig) => {
  return apiBase("post", baseURL, config, requestBody);
};
const deleteReport = async (path: string, config?: AxiosRequestConfig) => {
  const url = `${baseURL}${path}`;
  return apiBase("delete", url, config);
};
const patchReport = async (path: string, config?: AxiosRequestConfig) => {
  const url = `${baseURL}${path}`;
  return apiBase("patch", url, config);
};
export default { getAll, post, deleteReport, patchReport };
